import { useQuery } from 'react-query';
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting';
import { onError } from '~/utils/helpers';

const getMilkMoneyToursList = (data?, enabled = true) => useQuery(
  `milk-money-list-${JSON.stringify(data)}`,
  () => enabled && MilkMoneyAccountingService.getMilkMoneyToursList(data),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyToursOptions = () => useQuery(
  'milk-money-list-options',
  MilkMoneyAccountingService.getMilkMoneyToursOptions,
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyToursCount = (data, enabled = false) => useQuery(
  `milk-money-list-count-${data.search}`,
  () => enabled && MilkMoneyAccountingService.getMilkMoneyToursCount(data),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  },
)

const getMilkMoneySpecificTourData = (id, data) => useQuery(
  'milk-money-specific-tour',
  () => MilkMoneyAccountingService.getSpecificToursData(id, data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerMilkDeliveries = (data) => useQuery(
  'milk-money-farmer-deliveries',
  () => MilkMoneyAccountingService.getFarmerMilkDeliveries(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerMilkOptions = () => useQuery(
  'milk-money-farmer-options',
  MilkMoneyAccountingService.getFarmerMilkOptions,
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkSamplesData = (id, data) => useQuery(
  `milk-money-milk-samples-${id}`,
  () => MilkMoneyAccountingService.getMilkSamplesIndexData(id, data),
  {
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkSamplesFilterData = (id) => useQuery(
  'milk-money-milk-samples-filter',
  () => MilkMoneyAccountingService.getMilkSamplesFilterData(id),
  {
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyFtpLogs = (data) => useQuery(
  'milk-money-milk-ftp-logs',
  () => MilkMoneyAccountingService.getMilkMoneyFtpLogs(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyLogsOptions = () => useQuery(
  'milk-money-logs-options',
  MilkMoneyAccountingService.getMilkMoneyLogsOptions,
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyTourPlanning = (data) => useQuery(
  'milk-money-tour-planning',
  () => MilkMoneyAccountingService.getTourPlanningRows(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyShopOptions = () => useQuery(
  'milk-money-article-options',
  MilkMoneyAccountingService.getMilkMoneyShopOptions,
  {
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const checkUniqueId = (data) => useQuery(
  'check-unique-id',
  () => MilkMoneyAccountingService.checkUniqueId(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneyArticles = (data) => useQuery(
  'milk-money-articles',
  () => MilkMoneyAccountingService.getMilkMoneyArticles(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkMoneySettings = (id) => useQuery(
  'milk-money-articles',
  () => MilkMoneyAccountingService.articleSettingsData(id),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getInvoices = (data, enabled = false) => useQuery(
  'milk-money-invoices',
  () => enabled && MilkMoneyAccountingService.getInvoices(data),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getInvoiceSettings = (data?) => useQuery(
  'milk-money-invoices-settings',
  () => MilkMoneyAccountingService.getInvoiceSettings(data),
  {
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getInvoicePrintSettings = () => useQuery(
  'milk-money-invoices-print-settings',
  MilkMoneyAccountingService.getInvoicePrintSettings,
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmDeliveries = (data) => useQuery(
  'milk-money-farm-deliveries',
  () => data && MilkMoneyAccountingService.getFarmDeliveries(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data?.data
    }
  }
)

const getFarmDeliveriesData = () => useQuery(
  'milk-money-farm-deliveries-data',
  MilkMoneyAccountingService.getFarmDeliveriesData,
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmQualityList = (data) => useQuery(
  'milk-money-farm-quality',
  () => data && MilkMoneyAccountingService.getFarmQualityList(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data?.data
    }
  }
)

const getFarmQualityData = () => useQuery(
  'milk-money-farm-quality-data',
  MilkMoneyAccountingService.getFarmQualityData,
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmInvoices = (data) => useQuery(
  'milk-money-farm-invoices',
  () => MilkMoneyAccountingService.getFarmInvoices(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getTourTemplateData = (data?) => useQuery(
  'milk-money-tour-teplate-data',
  () => MilkMoneyAccountingService.getTourTemplateData(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getPartialMilkMoneySettings = (data) => useQuery(
  'milk-partial-settings',
  () => MilkMoneyAccountingService.getPartialInvoiceSettings(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getPartialInvoices = (data, enabled = false) => useQuery(
  'milk-partial-money-invoices',
  () => enabled && MilkMoneyAccountingService.getPartialInvoices(data),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getAdditionalInvoiceSettings = (data) => useQuery(
  'milk-additional-settings',
  () => MilkMoneyAccountingService.getAdditionalInvoiceSettings(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getAdditionalInvoices = (data, enabled = false) => useQuery(
  'milk-additional-money-invoices',
  () => enabled && MilkMoneyAccountingService.getAdditionalInvoices(data),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const optionsDataTour = () => useQuery(
  'milk-options-data-tour',
  () => MilkMoneyAccountingService.optionsDataTour(),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getTempToursOptions = () => useQuery(
  'temp-tours-data-options',
  MilkMoneyAccountingService.getTempToursOptions,
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getTempTours = (data?: any) => useQuery(
  'temp-tours',
  () => data?.month && MilkMoneyAccountingService.getTempTours(data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getTempTourData = (id: string, data?: any) => useQuery(
  'temp-tour-data',
  () => MilkMoneyAccountingService.getTempTourData(id, data),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissMilkSamplesOptions = () => useQuery(
  'swiss-milk-samples-options',
  MilkMoneyAccountingService.getSwissMilkSamplesOptions,
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissMilkSamples = (data?: any) => useQuery(
  'swiss-milk-samples',
  () => data?.month && MilkMoneyAccountingService.getSwissMilkSamples(data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissAvgFarmerValuesOptions = () => useQuery(
  'swiss-avg-farmer-values-options',
  MilkMoneyAccountingService.getSwissAvgFarmerValuesOptions,
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissAvgFarmerValues = (data?: any) => useQuery(
  'swiss-avg-farmer-values',
  () => data?.month && MilkMoneyAccountingService.getSwissAvgFarmerValues(data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getMilkMoneyLogs = (data?: any) => useQuery(
  'milk-money-logs',
  () => data?.month && MilkMoneyAccountingService.getMilkMoneyLogs(data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

export const MilkMoneyQuery = {
  getMilkMoneyToursCount,
  getMilkMoneyToursList,
  getMilkMoneyToursOptions,
  getMilkMoneySpecificTourData,
  getFarmerMilkDeliveries,
  getMilkSamplesData,
  getMilkSamplesFilterData,
  getMilkMoneyFtpLogs,
  getMilkMoneyLogsOptions,
  getFarmerMilkOptions,
  getMilkMoneyTourPlanning,
  getMilkMoneyShopOptions,
  checkUniqueId,
  getMilkMoneyArticles,
  getMilkMoneySettings,
  getInvoices,
  getInvoiceSettings,
  getInvoicePrintSettings,
  getFarmDeliveries,
  getFarmDeliveriesData,
  getFarmQualityData,
  getFarmQualityList,
  getFarmInvoices,
  getPartialMilkMoneySettings,
  getTourTemplateData,
  getPartialInvoices,
  getAdditionalInvoiceSettings,
  getAdditionalInvoices,
  optionsDataTour,
  getTempToursOptions,
  getTempTours,
  getTempTourData,
  getSwissMilkSamples,
  getSwissMilkSamplesOptions,
  getSwissAvgFarmerValues,
  getSwissAvgFarmerValuesOptions,
  getMilkMoneyLogs
}
